import { chakra, forwardRef, ImageProps } from "@chakra-ui/react";
import logo from "assets/footerDisclaimerLogos/CMELogo.svg";

export const CMELogo = forwardRef<ImageProps, "img">((props, ref) => {
  return <chakra.img src={logo} ref={ref} {...props} />;
});
